import { Table, Badge } from "antd";
import Layout, { Content, Header } from "antd/es/layout/layout";
import React, { useState } from "react";
import check from "../../icons/Check.svg";
import confirm from "../../icons/confirm.svg";
import danger from "../../icons/danger.svg";
import editing from "../../icons/Editing.svg";
import checkAll from "../../icons/CheckAll.svg";
import CustomFilter from "../customFilter/CustomFilter";
import {  getStaticExpertFields } from "../../service/api";
import { useQuery } from "@tanstack/react-query";
function MyPlans() {

const staticExpertFieldsQuery = useQuery(["staticsExpertFields"], getStaticExpertFields);

const questionnairesStates = staticExpertFieldsQuery?.data?.QUESTIONNAIRES_STATES

  const [data , setData] = useState()
  const [loading , setLoading] = useState()


const columns = [
  {
    title: "نام کشاورز",
    dataIndex: "name",
    key: "name",
    
    
    
  },
  {
    title: "نوع کشت",
    dataIndex: "product",
    key: "product",
  },
  {
    title: "مساحت",
    dataIndex: "area",
    key: "area",
  },
  {
    title: "منطقه",
    dataIndex: "location",
    key: "location",
  },
  {
    title: "تاریخ انجام بازدید",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "وضعیت",
    dataIndex: "state",
    key: "state",
    render:
     (data) => {
      if (data.status === "ARCHIVED") {
        return (
          <div className="flex flex-row-reverse justify-around shadow-sm rounded-3xl p-2">
            {" "}
            <img alt="danger" src={danger} />{" "}
            <Badge color="#F11D59" text={"عدم تایید"} />
          </div>
        );
      } else if (data.status === "COMPLETED") {
        return (
          <div className="flex flex-row-reverse justify-around shadow-sm rounded-3xl p-2">
            <img alt="checkAll" src={checkAll} />
            <Badge color="#207E4F" text={"تایید شده"} />
          </div>
        );
      } else if (
        (data.currentState === "QUESTIONNAIRE_MEAL_PLAN_WRITING") &
        (data.status === "PROCESSING")
      ) {
        return (
          <div className="flex flex-row-reverse justify-around shadow-sm rounded-3xl p-2">
            <img alt="edit" src={editing} />
            <Badge color="#E8EC18" text={"در حال نگارش"} />
          </div>
        );
      } else if (
        data.currentState === "EDUCATION_MANAGEMENT" ||
        (data.currentState === "QUESTIONNAIRE_MANAGEMENT") &
          (data.status === "PROCESSING") &
          (data.mealPlanFile !== null)
      ) {
        return (
          <div className="flex flex-row-reverse justify-around shadow-sm rounded-3xl p-2 ">
            {" "}
            <img alt="check" src={confirm} />{" "}
            <Badge color="#22FF71" text={"کنترل و تایید"} />
          </div>
        );
      } else if (
        data.currentState === "QUESTIONNAIRE_MANAGEMENT" ||
        (data.currentState === "QUESTIONNAIRE_SUPPORT") &
          (data.status === "PROCESSING") &
          (data.mealPlanFile === null)
      ) {
        return (
          <div className="flex flex-row-reverse justify-around shadow-sm rounded-3xl p-2">
            {" "}
            <img alt="check" src={check} />{" "}
            <Badge color="#9D9D9D" text={"در حال بررسی"} />
          </div>
        );
      } else {
        return (
          <Badge
            className="shadow-sm "
            style={{ width: "160px" }}
            color="#f10808"
            text="نامشخص"
          />
        );
      }
    },
  },
  {
    title: "عملیات",
    dataIndex: "operation",
    key: "operation",
    

    render: (data) => {
      if (data?.mealPlanFile === null) {
        return (
          <div
            style={{
              border: " 1px solid #EEE",
              borderRdivdius: "15px",
              boxShadow: "0px 2px 8px 0px rgba(219, 219, 219, 0.50)",
              padding: "4px 6px",
              borderRadius: "20px",
              whiteSpace:'nowrap',
              width: "85%",
              margin: "auto",
              opacity: "50%",
            }}
          >
            <p>در انتظار نگارش</p>
          </div>
        );
      } else if (data?.mealPlanFile !== null) {
        return (
          <a
            style={{
              
              border: " 1px solid #EEE",
              borderRadius: "15px",
              boxShadow: "0px 2px 8px 0px rgba(219, 219, 219, 0.50)",
              padding: "4px 15px",
            }}
            href={data?.mealPlanFile}
            target="_blank"
            rel="noreferrer"
          >
            مشاهده برنامه
          </a>
        );
      } else {
        return <p>error</p>;
      }
    },
  },
];

  return (
    <Layout className="p-3 ">
      <Content className="bg-white  shadow-lg rounded-lg p-3 max-lg:w-full">
        <Header className="text-[#00817A] bg-[#FFF] max-lg:m-auto text-[2.3rem] max-lg:text-[1.5rem] mx-[1rem] font-body mt-3 rounded-lg mb-5 max-lg:text-3xl max-lg:whitespace-nowrap max-lg:items-center ">
          <span>برنامه کودی‌های من</span>
        </Header>
          <p className="text-[#00817A] font-body text-base mb-2">لیست تمام برنامه کودی هایی که از صفحه شخصی شما درخواست شده است</p>
        <div className="pb-3">
          <CustomFilter states={questionnairesStates} setData={setData} setLoading={setLoading} />
        </div>
        <Table
         scroll={{
          x: 950,
        }}
        
        loading={loading ? true :false}
          showHeader={true}
          pagination={false}
          className="max-lg:overflow-auto max-lg:w-full"
          style={{
            fontFamily: "body",
          }}
          dataSource={data}
          columns={columns}
          
        ></Table>
      </Content>
    </Layout>
  );
}

export default MyPlans;
